import { ApiClient } from "./client";
import { FetchTransport } from "./transports/fetch-transport";

const browserTransport = new FetchTransport({ basePath: "/api/v1" });

export const apiClient = new ApiClient(browserTransport);
